export default "__VITE_ASSET__2f2170b2__"